import { createAction, props } from '@ngrx/store';

import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';
import { Localidad } from './entity-localidades.model';

// LOAD
export const entityLocalidadesAllLoadRequest = createAction(
  '[ENTITYLOCALIDADES] Load Request'
);

export const entityLocalidadesLoadRequest = createAction(
  '[ENTITYLOCALIDADES] Load Request',
  props<{ q: string }>()
);

export const entityLocalidadesLoadFailure = createAction(
  '[ENTITYLOCALIDADES] Load Failure',
  props<{ error: Error }>()
);

export const entityLocalidadesLoadSuccess = createAction(
  '[ENTITYLOCALIDADES] Load Success',
  props<{ items: Localidad[] }>()
);

